import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { IframeBannerComponent } from './iframe-banner.component';

export { IframeBannerModule } from './iframe-banner.module';
export const ngxIframeBannerModule = angular.module('ngxIframeBannerModule', [])
	.directive('ngxIframeBanner', downgradeComponent({ component: IframeBannerComponent }))
	.name;
